/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import { memo, useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import SelectField from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { rowsOptions } from "src/helpers/Dashboard/resources";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import store from "src/redux/store";
import { setLimit, setPageNo } from "src/redux/Actions/dashboard";

function TablePagination() {
  const totalPages = useAppSelector((state) => state.dashboard?.data?.totalPages);
  const tableDataLength = useAppSelector((state) => state.dashboard?.data?.totalItems);
  const limit = useAppSelector((state) => state.dashboard?.limit);
  const pageNo = useAppSelector((state) => state.dashboard.pageNo);
  const rowOptions = rowsOptions({ tableDataLength, pageNo });
  const handlePagination = (event: any, value: number) => {
    store.dispatch(setPageNo(value));
  };
  const handleSelectRows = (event: any) => {
    store.dispatch(setLimit(event.target.value));
  };
  const [rowIndex, setRowIndex] = useState({
    start: 1,
    end: tableDataLength < limit ? tableDataLength : limit
  });
  useEffect(() => {
    setRowIndex({
      start: limit * (pageNo - 1) + 1,
      end: limit * pageNo > tableDataLength ? tableDataLength : limit * pageNo
    });
  }, [limit, pageNo, tableDataLength]);

  return (
    <div className="flex flex-col md:flex-row md:justify-end md:space-x-3 space-y-4 md:space-y-0 py-2 items-center text-sm">
      <div className="flex sm:space-y-0 space-x-3 sm:justify-center">
        <div className="flex items-center justify-center space-x-2 !font-montserrat">
          <span className="text-xs leading-3.75 -tracking-0.01 !text-nightSky font-medium">
            Page
          </span>
          {rowOptions.length && (
            <SelectField
              value={limit}
              margin="none"
              // eslint-disable-next-line react/no-unstable-nested-components
              IconComponent={() => (
                <ExpandMoreIcon
                  fontSize="small"
                  className="!p-0 !cursor-pointer !text-palladium absolute right-0 pointer-events-none"
                />
              )}
              defaultValue={rowOptions[0]}
              inputProps={{
                className: "!py-0.5 !pl-3 !pr-6 !font-montserrat !text-black"
              }}
              onChange={handleSelectRows}
            >
              {rowOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <span className="text-xs !leading-3 !font-montserrat !text-black">{option}</span>
                </MenuItem>
              ))}
            </SelectField>
          )}
        </div>
        <div className="tracking-widest text-nightSky opacity-50 flex items-center">
          {`${rowIndex.start} - ${rowIndex.end} of ${tableDataLength} items`}
        </div>
      </div>
      <div>
        <Pagination
          page={pageNo}
          color="primary"
          count={totalPages}
          shape="rounded"
          size="small"
          onChange={handlePagination}
        />
      </div>
    </div>
  );
}

export default memo(TablePagination);
